import React, { useReducer } from 'react';
import './../../styles/irctcCreateAccount.css';
import './../../styles/UpdateCenterCommon.css';
import { BreadCrumb, FooterSection } from '../components';
import IrctcCreateAccountForms from './components/IrctcCreateAccountForms';
import SimilarQuestions from '../components/SimilarQuestions';
import IrctcFaq from '../components/IrctcFaq';
import {
  FOOTER_DATA_IRCTC,
  IRCTC_BREAD_CRUMB_COMMON,
  IRCTC_CREATE_ACCOUNT_COMPONENTS,
  IRCTC_EXTERNAL_JS,
  IRCTC_FAQ_TITLE,
  SIMILAR_QUESTIONS_TITLE
} from '../../utils/RailsSEOConstants';
import IrctcOtpVerifyPage from './components/IrctcOtpVerifyPage';
import IrctcCreateAccountSuccessPage from './components/IrctcCreateAccountSuccessPage';
import { FirstBookingPersuation } from '../components/FirstBookingPersuation';
import { irctcCreateAccountInitialState, irctcCreateAccountReducer } from '../../reducers/irctcCreateAccountReducer';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';
import HtmlHeader from '../components/HtmlHeader';
import AdWrapper from '../components/AdWrapper';
import { AD_PAGES } from '../../utils/adsUtils';
import PropTypes from 'prop-types';
import { searchWidgetInitialState, searchWidgetReducer } from '../../reducers/searchWidgetReducer';
import SearchWidget from '../components/SearchWidget/SearchWidget';
import { TrainClasses } from '../route_info/TrainClasses';
export const IrctcCreateAccountContext = React.createContext<any>(irctcCreateAccountInitialState);
const SearchWidgetContext = React.createContext<any>(searchWidgetInitialState);

const IrctcCreateAccountPage = (props) => {
  const { data } = props;
  const [state, dispatch] = useReducer(irctcCreateAccountReducer, irctcCreateAccountInitialState);
  const [searchWidgetState, searchWidgetDispatch] = useReducer(searchWidgetReducer, searchWidgetInitialState);
  const { componentToShow } = state;
  const {
    template: { h1_title: IRCTC_CREATE_ACCOUNT_TITLE }
  } = data;
  return (
    <IrctcCreateAccountContext.Provider value={{ createAccountState: state, createAccountDispatch: dispatch }}>
      <HtmlHeader data={data} />
      <SearchWidgetContext.Provider value={{ searchWidgetState, searchWidgetDispatch }}>
        <SearchWidget
          openDatePickerOnMount={false}
          topFix={true}
          classNode={TrainClasses.FC}
          modifySearchProps={true}
          pageWiseContext={SearchWidgetContext}
        />
      </SearchWidgetContext.Provider>
      <main className="container irctcLogin">
        <div className={`append_bottom30 appendTop30`}>
          <AdWrapper adsPageName={AD_PAGES.IRCTC_CREATE_ACCOUNT_PAGE.adsPageName} />
        </div>
        <div className="appendBottom20">
          <BreadCrumb breadcrumb={data.template.breadcrumb} noLeftPadding />
        </div>
        <h1 className={'appendBottom15 font24'}>{IRCTC_CREATE_ACCOUNT_TITLE}</h1>
        {componentToShow === IRCTC_CREATE_ACCOUNT_COMPONENTS.inputForm && (
          <IrctcCreateAccountForms customClass="appendBottom40" />
        )}
        {componentToShow === IRCTC_CREATE_ACCOUNT_COMPONENTS.otpVerificationForm && (
          <IrctcOtpVerifyPage customClass="appendBottom40" />
        )}
        {componentToShow === IRCTC_CREATE_ACCOUNT_COMPONENTS.successPage && (
          <IrctcCreateAccountSuccessPage customClass="appendBottom40" />
        )}
        <FirstBookingPersuation />
        <h2>{SIMILAR_QUESTIONS_TITLE}</h2>
        <SimilarQuestions customClass="appendBottom40" />
        <h2>{IRCTC_FAQ_TITLE}</h2>
        <IrctcFaq customClass="appendBottom40" />
      </main>
      <FooterSection template={data.template} />
    </IrctcCreateAccountContext.Provider>
  );
};
IrctcCreateAccountPage.propTypes = {
  data: PropTypes.object
};
IrctcCreateAccountPage.fetchData = async (_, match, urlObj) => {
  const template = {
    template_name: `irctc-create-account`,
    meta_title: `Create IRCTC Account | IRCTC Registration | IRCTC Login - MakeMyTrip`,
    meta_description: `Create IRCTC Account with MakeMyTrip by filling up relevant information which make your train ticket booking experience easier and faster.`,
    meta_keywords: `IRCTC Account login,create IRCTC Login,IRCTC Next Generation Login`,
    analytics: getStaticPageLoadEvent('seo:rails:irctccreateaccount'),
    footer_data: FOOTER_DATA_IRCTC,
    h1_title: `Create IRCTC Account`,
    breadcrumb: [
      ...IRCTC_BREAD_CRUMB_COMMON,
      {
        displayString: `IRCTC Create Account`,
        redirectionUrl: `https://www.makemytrip.com/railways/irctc-create-account.html`
      }
    ],
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: `https://www.makemytrip.com/railways/irctc-create-account.html`,
    external_js: IRCTC_EXTERNAL_JS,
    extra_info: ``
  };

  const finalResponse = {
    template
  };
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_IRCTC-CREATE-ACCOUNT.HTML';
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    pageType,
    ...finalResponse
  };
};

export default IrctcCreateAccountPage;
